import React from 'react';
import './Footer.css'
import {Container, Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom'
import { FooterLinks } from '../../data/footer.data';

function Footer() {
    return (

      
        <footer >
          

          <div className='footer-last-row'> 
                © 2022, All rights reserved
            
          </div>
                  

           

            
        </footer>
    )
}

export default Footer
